import { render, staticRenderFns } from "./EducationArchive.vue?vue&type=template&id=4d2fba10&scoped=true&"
import script from "./EducationArchive.vue?vue&type=script&lang=js&"
export * from "./EducationArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2fba10",
  null
  
)

export default component.exports